var React = require('react');

function Close (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M4.943 4l2.862-2.862a.666.666 0 1 0-.943-.943L4 3.057 1.138.195a.666.666 0 1 0-.943.943L3.057 4 .195 6.862a.666.666 0 1 0 .943.943L4 4.943l2.862 2.862a.665.665 0 0 0 .943 0 .666.666 0 0 0 0-.943L4.943 4z","fill":"#6F7881","fillRule":"evenodd"}));
}

Close.defaultProps = {"width":"8","height":"8","viewBox":"0 0 8 8"};

module.exports = Close;

Close.default = Close;
